import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={7}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/martbook/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={740}
              height={941}
            />
          </Col>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#259354" }}>Solution</span>
            </h2>
            <p>
              A simple and intuitive user interface and a visually rich
              experience, we have designed and built the Mart Book app to
              provide users valuable experience. We have also offered impeccable
              ease for users with seamless and well-planned user journey.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
